'use client';

import { useSearchParams } from 'next/navigation';
import { createContext, ReactNode, useEffect, useState } from 'react';
import {
  FoodDetailDataType,
  searchFood as searchFoodReqeuest,
} from 'utils/foodGlucoseDbHelper';

interface SearchContextType {
  query: string | null;
  setQuery: (query: string) => void;

  search: (query: string) => void;
  searchResponse: FoodDetailDataType[];
  incrementPage: () => void;
  clear: () => void;

  page: number;
  count: number;
  setCount: (count: number) => void;
}

export const FoodGlucoseSearchContext = createContext<SearchContextType>({
  query: null,
  setQuery: () => undefined,

  search: () => undefined,
  searchResponse: [],
  incrementPage: () => undefined,
  clear: () => undefined,

  page: 1,
  count: 30,
  setCount: () => undefined,
});

export const FoodGlucoseSearchContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const searchParams = useSearchParams();
  const q = searchParams?.get('q') ?? null;
  const [query, setQuery] = useState<string | null>(q);
  const [searchResponse, setSearchResponse] = useState<FoodDetailDataType[]>(
    [],
  );
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState<number>(30);

  useEffect(() => {
    if (!q) return;
    setQuery(q);
  }, [q]);

  const search = (input: string) => {
    if (!input) return;
    try {
      searchFoodReqeuest({ query: input, count, page })
        .then((res) => {
          setSearchResponse(res);
          setQuery(input);
        })
        .catch((e) => {
          throw new Error(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const incrementPage = () => {
    try {
      searchFoodReqeuest({ query: query as string, count, page: page + 1 })
        .then((res) => {
          if (Array.isArray(res) && res.length > 0) {
            setSearchResponse((prev) => prev.concat(res));
            const newPage = page + 1;
            setPage(newPage);
          }
        })
        .catch((e) => {
          throw new Error(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const clear = () => {
    setSearchResponse([]);
  };

  return (
    <FoodGlucoseSearchContext.Provider
      value={{
        query,
        setQuery,
        search,
        searchResponse,
        incrementPage,
        clear,
        page,
        count,
        setCount,
      }}
    >
      {children}
    </FoodGlucoseSearchContext.Provider>
  );
};
